import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface ExitSetupModalProps {
  isOpen: boolean;
  onContinue: () => void;
  onDiscard: () => void;
}

const ExitSetupModal: React.FC<ExitSetupModalProps> = ({
  isOpen,
  onContinue,
  onDiscard,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[var(--modal-overlay-background)] bg-opacity-50 flex items-end md:items-center justify-center z-[1100] zoomOutLevel">
      <div className="bg-[var(--modal-background)] rounded-t-[20px] md:rounded-[20px] w-full md:max-w-sm max-w-3xl sm:mx-4 p-6 pt-8 shadow-xl animate-scale-in text-center">
        {/* Warning icon */}
        <div className="mx-auto mb-4 w-12 h-12 bg-[#FFF7E6] rounded-full flex items-center justify-center">
          <AlertTriangle className="h-6 w-6 text-[#E5A000]" />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-[var(--color-text)] mb-2">
          Exit device setup?
        </h3>

        {/* Message */}
        <p className="text-sm text-[var(--color-sub-title-text)] mb-6 leading-relaxed">
          Your device isn&apos;t fully set up yet. Do you want to continue with
          the onboarding, or discard your progress and go back?
        </p>

        {/* Continue onboarding — primary gradient button */}
        <button
          type="button"
          onClick={onContinue}
          className="dcf-button dcf-button--primary w-full mb-3"
          style={{ minHeight: 48, borderRadius: 12, fontSize: 15, fontWeight: 600 }}
        >
          Continue onboarding
        </button>

        {/* Discard & go back — text-only secondary */}
        <button
          type="button"
          onClick={onDiscard}
          className="w-full py-2 text-sm font-semibold text-[var(--color-text)] bg-transparent border-none cursor-pointer"
        >
          Discard &amp; go back
        </button>
      </div>
    </div>
  );
};

export default ExitSetupModal;
